import { render, staticRenderFns } from "./FieldStatistics.vue?vue&type=template&id=286698a4"
import script from "./FieldStatistics.vue?vue&type=script&lang=ts"
export * from "./FieldStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports